<template>
  <div class="table-footer">
    <div class="row">
      <div class="col-md-4">
        <span>Show</span>
        <select
          class="form-control"
          v-model="keywordShowPerPage"
          id="resultsPerPage"
          @change="showPerPageChanged"
        >
          <option>10</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
        <span>Entries</span>
      </div>
      <div class="col-md-4 text-center">
        <!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
				</button>-->
      </div>
      <div class="col-md-4 text-right">
        <a
          href="javascript:void(0)"
          v-if="keywordCurrentPageNumber != 1"
          @click="getPreviousPageList()"
          >Previous</a
        >
        <select
          class="form-control selectpicker"
          style="max-width:80px;"
          id="brandFilter"
          v-model="keywordCurrentPageNumber"
          @change="getNewPageList()"
        >
          <option v-for="index in totalNoOfPages" :key="index" :value="index">{{
            index
          }}</option>
        </select>
        <a
          href="javascript:void(0)"
          v-if="keywordShowPerPage == keywordList.length"
          @click="getNextPageList()"
          >Next</a
        >
        <div style="padding-right:0px;padding-top:5px">{{ getCount() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignGroupGridFooter",
  data() {
    return {
      totalNoOfPages: 1,
    };
  },
  watch: {
    totalKeywordCount() {
      this.calculateIndexPerPage();
    },
  },
  computed: {
    totalKeywordCount: {
      set(val) {
        return (this.$store.state.totalKeywordCount = val);
      },
      get() {
        return this.$store.state.totalKeywordCount;
      },
    },
    keywordShowPerPage: {
      set(val) {
        sessionStorage.setItem("keyword:keywordShowPerPage", val);
      },
      get() {
        if (sessionStorage.getItem("keyword:keywordShowPerPage")) {
          return sessionStorage.getItem("keyword:keywordShowPerPage");
        }
        return this.$store.state.keywordShowPerPage;
      },
    },
    keywordCurrentPageNumber: {
      set(val) {
        this.resetKeyAction();
        this.$store.state.keywordCurrentPageNumber = val;
      },
      get() {
        return this.$store.state.keywordCurrentPageNumber;
      },
    },
    keywordList() {
      return this.$store.state.keywordList;
    },
  },
  mounted() {
    this.calculateIndexPerPage();
  },
  methods: {
    resetKeyAction() {
      this.$store.state.campaign.actionSelectionControl = false;
      this.$store.state.campaign.keyWordToTagList = [];
    },
    calculateIndexPerPage() {
      this.totalNoOfPages = Math.ceil(
        this.totalKeywordCount / this.keywordShowPerPage
      );
    },
    getPreviousPageList() {
      if (this.keywordCurrentPageNumber <= 1) {
        return;
      } else {
        this.keywordCurrentPageNumber -= 1;
        //this.$store.dispatch("campaign/getCampaignGroupList");
        this.$emit("showPerPageChanged");
      }
    },
    getNextPageList() {
      this.keywordCurrentPageNumber += 1;
      //this.$store.dispatch("campaign/getCampaignGroupList");
      this.$emit("showPerPageChanged");
    },
    getNewPageList() {
      //this.$store.dispatch("campaign/getCampaignGroupList");
      this.$emit("showPerPageChanged");
    },
    getCount() {
      let pageCount =
        this.keywordShowPerPage * (this.keywordCurrentPageNumber - 1);
      let extendedcount =
        parseInt(pageCount) + parseInt(this.keywordList.length);
      //return	pageCount+1 + ' to ' + extendedcount;
      return (
        "Showing " +
        (pageCount + 1) +
        " to " +
        extendedcount +
        " results of " +
        this.totalKeywordCount
      );
    },
    showPerPageChanged() {
      this.keywordCurrentPageNumber = 1;
      this.$emit("showPerPageChanged");
      //this.$store.dispatch("campaign/getCampaignGroupList");
    },
  },
};
</script>

<style lang="scss"></style>
